import * as types from "../constants/actionConstants";


const initialState = {};

function groupTemplateGraphReducer(state = initialState, action) {
    switch (action.type) {
        case types.GET_GROUP_GRAPH_SUCCESS:
            return {...action.groupTemplateGraph};
        case types.CLEAR_GROUP_GRAPH:
            return {...initialState};
        default:
            return state;
    }
}

export default groupTemplateGraphReducer;